import { jsxs as p, jsx as l } from "react/jsx-runtime";
import { E as d, S as u } from "./icons.types-0722eef5.js";
function f({ title: n, titleId: r, size: h, width: a, height: o, extended: s = !1, ...c }) {
  const i = s ? d : u, t = h ? i[h] : a || i[s ? "s" : "l"], e = h ? i[h] : o || i[s ? "s" : "l"];
  return /* @__PURE__ */ p(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 64 64",
      width: t,
      height: e,
      "aria-labelledby": r,
      ...c,
      children: [
        n ? /* @__PURE__ */ l("title", { id: r, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Pushpin_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "m47.79 35.562-1.216-3.922a1.961 1.961 0 0 0-1.753-1.083h-1.67l-2.463-14.555H44a.8.8 0 0 0 .8-.8v-4.8a.8.8 0 0 0-.8-.8h-24a.8.8 0 0 0-.8.8v4.8a.8.8 0 0 0 .8.8h3.314l-2.464 14.555h-1.669a1.96 1.96 0 0 0-1.753 1.083l-1.216 3.922c-.652 1.304.296 2.838 1.753 2.838h8.567l4.41 15.174c.127 1.101 1.994 1.101 2.122 0l4.41-15.174h8.566a1.96 1.96 0 0 0 1.754-2.838h-.005Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Pushpin_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h64v64H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  f as Pushpin
};
